import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { ConfigRequest, PaginationDataObject } from '#models';
import type { ChatroomDataObject } from '#models/services';
import { routes } from '#routes';

type GetChatroomsDataObject = PaginationDataObject<ChatroomDataObject>;
type GetChatroomsRequest = NonNullable<paths['/chatrooms']['get']['parameters']['query']>;

export const getChatrooms = async ({ config }: ConfigRequest<GetChatroomsRequest>) =>
  getNodeApiAxiosInstance().get<GetChatroomsDataObject, AxiosResponse<GetChatroomsDataObject>>(
    routes.chatrooms.find,
    config,
  );
